import { useState } from "react";
import { getOptimizedImageUrl } from "../lib/cms";

export default function FAQSection({
  title = "Ofte stillede spørgsmål",
  subtitle = "Få hurtige svar på typiske spørgsmål om tagarbejde, vinduer, tømreropgaver og renovering.",
  faqs = []
}) {
  const [openIndex, setOpenIndex] = useState(0);

  if (!faqs || faqs.length === 0) return null;

  return (
    <section className="py-16 sm:py-24 bg-[#142334] text-white border-t border-stone-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-14 items-stretch">
          {/* Left Column: Single large flush-edged image filling container */}
          <div className="lg:col-span-5 flex">
            <div className="w-full h-full min-h-[380px] lg:min-h-[520px] rounded-2xl overflow-hidden relative shadow-2xl border border-stone-700/50 bg-stone-800">
              <img
                src={getOptimizedImageUrl(
                  "https://assets.auxodev.dk/assets/f0baa3a2-6eb6-4b57-8f55-7b5fb1f2d6b7/montering-af-tegltag-med-ovenlys.jpg",
                  { width: 900 }
                )}
                alt="Tømrerarbejde og tagmontage i Ribe"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#142334]/80 via-transparent to-transparent"></div>
              <div className="absolute bottom-6 left-6 right-6 p-4 rounded-xl bg-[#142334]/90 backdrop-blur-md border border-stone-700/60">
                <p className="text-xs font-semibold text-red-400 uppercase tracking-wider">
                  Faglig ekspertise
                </p>
                <p className="text-sm text-stone-200 mt-1 font-medium">
                  Har du yderligere spørgsmål til dit byggeprojekt? Vi er altid klar med et uforpligtende svar.
                </p>
              </div>
            </div>
          </div>

          {/* Right Column: FAQ Accordion List */}
          <div className="lg:col-span-7 flex flex-col justify-center">
            {/* Header Area */}
            <div className="mb-8">
              <div className="inline-flex items-center space-x-2 px-3 py-1 rounded-full bg-red-500/10 border border-red-500/30 text-red-400 text-xs font-semibold uppercase tracking-wider mb-3">
                <i className="fa-solid fa-circle-question" aria-hidden="true"></i>
                <span>Værd at vide</span>
              </div>
              <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-white tracking-tight">
                {title}
              </h2>
              {subtitle && (
                <p className="mt-3 text-stone-300/80 italic text-sm sm:text-base leading-relaxed">
                  {subtitle}
                </p>
              )}
            </div>

            {/* Accordion list with thin divider lines */}
            <div className="border-t border-stone-700/60 divide-y divide-stone-700/60">
              {faqs.map((faq, index) => {
                const isOpen = openIndex === index;
                return (
                  <div key={index} className="py-4 transition-colors">
                    <button
                      type="button"
                      onClick={() => setOpenIndex(isOpen ? -1 : index)}
                      className="w-full text-left flex items-center justify-between text-white font-semibold text-base sm:text-lg group hover:text-red-400 transition-colors cursor-pointer py-1"
                      aria-expanded={isOpen}
                    >
                      <span className="pr-4 leading-snug">{faq.question}</span>
                      <i
                        className={`fa-solid fa-chevron-down text-sm text-red-400 shrink-0 transition-transform duration-300 ${
                          isOpen ? "rotate-180 text-red-300" : "text-stone-400 group-hover:text-red-400"
                        }`}
                        aria-hidden="true"
                      ></i>
                    </button>
                    <div
                      className={`grid transition-all duration-300 ease-in-out ${
                        isOpen ? "grid-rows-[1fr] opacity-100 mt-2" : "grid-rows-[0fr] opacity-0"
                      }`}
                    >
                      <div className="overflow-hidden">
                        <div className="pt-1 pb-2 pl-2 pr-4 text-stone-300 text-sm sm:text-base leading-relaxed">
                          {faq.answer}
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
